import { render } from "./Heading1.vue?vue&type=template&id=42179765&scoped=true&ts=true"
import script from "./Heading1.vue?vue&type=script&lang=ts"
export * from "./Heading1.vue?vue&type=script&lang=ts"

import "./Heading1.vue?vue&type=style&index=0&id=42179765&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42179765"]])

export default __exports__